import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TStore } from '@/common/basis/types/tstore';
import i18n from '@/common/basis/i18n';

export const useMeetingCopyText = (options: {
  roomName: string;
  roomId: string;
  brightPassword: string;
  webUrl: string;
  liveUrl?: string;
}) => {
  const userName = useSelector((state: TStore.State) => state.person.user?.userName) ?? '';
  const { roomName, roomId, brightPassword, webUrl, liveUrl } = options;

  return {
    meetingText: useMemo(() => {
      return [
        `${i18n.t('inviteMeeting', { userName })}\r\n`,
        `${i18n.t('theme')}: ${roomName}`,
        `${i18n.t('meetingId')}: ${roomId}`,
        `${i18n.t('joinPassword')}: ${brightPassword}`,
        `${i18n.t('meetingLink')}: ${webUrl}`,
        ...(liveUrl ? [`${i18n.t('audienceLink')}: ${liveUrl}`] : []),
      ].join('\n');
    }, [roomName, userName, roomId, brightPassword, webUrl, liveUrl]),
  };
};
